module.exports = {"511825100":"城厢镇","511825101":"始阳镇","511825200":"小河乡","511825201":"思经乡","511825202":"鱼泉乡","511825203":"紫石乡","511825204":"两路乡","511825205":"大坪乡","511825206":"乐英乡","511825207":"多功乡","511825208":"仁义乡","511825209":"老场乡","511825210":"新华乡","511825211":"新场乡","511825212":"兴业乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511825.json
// module id = 2200
// module chunks = 0